import React from 'react';
import { UPLOADS_BASE_URL } from "../utils/apiConfig";

const resolveSrc = (value) => {
    if (!value) return '';
    if (value.startsWith('http')) {
        return value;
    }
    return `${UPLOADS_BASE_URL}/${value.replace(/^\/+/, '')}`;
};

const ResponsiveImage = ({alt, src, desktop, tablet, mobile, className}) => {
    return (
        <picture className={className}>
            <picture>
                {/* WebP sources for modern browsers */}
                <source type="image/webp" media="(min-width: 1024px)" srcSet={desktop}/>
                <source type="image/webp" media="(min-width: 600px)" srcSet={tablet}/>
                <source type="image/webp" media="(max-width: 599px)" srcSet={mobile}/>

                {/* Fallback image */}
                <img src={resolveSrc(src)} alt={alt} loading="lazy" className={className}/>
            </picture>
        </picture>
    );
};

export default ResponsiveImage;
